import AlertIcon from '@/icons/AlertIcon.svg';
import LockIcon from '@/icons/LockIcon.svg';

type ErrorVariant = 'generic' | 'forbidden';

interface ErrorDisplayProps {
  error: string;
  variant?: ErrorVariant;
  title?: string;
  icon?: React.ReactNode;
  onRetry?: () => void;
  onLogout?: () => void;
  retryLabel?: string;
}

const VARIANT_CONFIG = {
  generic: {
    icon: AlertIcon,
    title: 'Error',
    defaultMessage: 'Something went wrong. Please try again.',
  },
  forbidden: {
    icon: LockIcon,
    title: 'Access Denied',
    defaultMessage: 'Oops! This area is restricted to administrators only.',
  },
};

function ErrorDisplay({
  variant = 'generic',
  title,
  error,
  icon,
  onRetry,
  onLogout,
  retryLabel = 'Retry',
}: ErrorDisplayProps) {
  const config = VARIANT_CONFIG[variant];
  const displayTitle = title ?? config.title;
  const displayMessage = config.defaultMessage ?? error;
  const displayIcon = icon ?? config.icon;

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md text-center">
        <div className="mb-8 flex justify-center">
          <img src={displayIcon as string} alt={displayTitle} className="size-48" />
        </div>
        <h1 className="mb-4 text-2xl font-bold text-gray-900">{displayTitle}</h1>
        <p className="mb-8 text-lg text-gray-600">{displayMessage}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="rounded-lg bg-red-500 px-6 py-3 font-bold text-white transition-colors hover:bg-red-600"
          >
            {retryLabel}
          </button>
        )}
        {onLogout && (
          <button
            onClick={onLogout}
            className={`${onRetry ? 'ml-4' : ''} rounded-lg bg-red-500 px-6 py-3 font-bold text-white transition-colors hover:bg-red-600`}
          >
            Logout
          </button>
        )}
      </div>
    </div>
  );
}

export { ErrorDisplay };
